// d3 の代わりの道具をまとめたもの（段階 C の2 の 7g、2026-10-26）。クラシック版のページは d3.min.js を読まない。
// TS の部品は S.select(...)・S.easeBackOut のように使い、前任者の処理（charat.legacy.js）・セーブスロット（slots.js）は同じものを window.charat.sel で使う。
// 速さの変わり方はページの chibiConfig.REVERSE_EASE の d3 の名前（"easeBounceInOut" など）で引けるように、同じ名前で並べる
import { color, rgb } from './color.js';
import { EASES } from './ease.js';
import { interpolate, interpolateNumber, interpolateRgb, interpolateString, interpolateTransformSvg } from './interpolate.js';
import { scaleLinear } from './scale.js';
import { event, select, selectAll } from './selection.js';

export const S = {
  select,
  selectAll,
  event,
  scaleLinear,
  interpolate,
  interpolateNumber,
  interpolateRgb,
  interpolateString,
  interpolateTransformSvg,
  rgb,
  color,
  ...EASES,
};
export type SelTools = typeof S;
